import React from 'react'
import Createcoursecomp from '../../components/student/createcourse'
export default function Createcourse() {
  return (
    <div>
        <Createcoursecomp/>
    </div>
  )
}
